<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9.00005H25M20 8.71429V7C20 6.44772 19.5523 6 19 6H13C12.4477 6 12 6.44771 12 7V8.71429" stroke="var(--icon-color)"
        stroke-width="2" stroke-linecap="round" />
    <path d="M9 11L9 25C9 26.1046 9.89543 27 11 27L21 27C22.1046 27 23 26.1046 23 25L23 11" stroke="var(--icon-color)"
        stroke-width="2" />
</svg>
